module.exports = __webpack_public_path__ + "img/Incoming green.74f70dfe.png";